<div
  *ngIf="property$ | async as property; else loading"
  class="property-dates"
  [attr.data-property-id]="property.id"
  [style.width.px]="cellWidth * 31">
  <ng-container *ngIf="date | date: 'yyyy-MM-dd' as dateString">
    <!-- reservations container-->
    <div
      *ngFor="let event of todaysEvents$ | async"
      class="event event-platform-{{ event.platform }} flex gap-3 items-center justify-between"
      [class.apply-event-colors]="true"
      [class.incorrect-mode]="(mode$ | async) !== 'occupancy'"
      [class.old-event]="event.end_date | isBeforeToday"
      [class.event-pending]="event.status === 'Pending' || event.status === 'Awaiting Payment'"
      [class.overlap-detected]="
        !event.isParentChildReservation && event | hasOverlapWithOtherReservations: property?.events
      "
      [class.fully-overlapped]="event | hasOverlapWithOtherReservations: property?.events : true"
      [class.small-event]="(event | eventWidth) < 60"
      [class.parent-child-reservation]="event.isParentChildReservation"
      [style.width.px]="event | eventWidth"
      [style.left.px]="event | eventOffset: calendarStartDate"
      (click)="reservationSelected.emit({ reservation: event, property })">
      <ng-container *ngIf="!event.isParentChildReservation">
        <!-- If an event starts before the calendar date, create an opposite left
           margin to push the guest name to the start of the calendar so its visible -->
        <span class="flex gap-3" [style.margin-left.px]="-(event | eventOffset: calendarStartDate)">
          <img
            *ngIf="event.guest_thumbnail && event.guest_thumbnail !== '#'"
            class="w-5 h-5 min-w-5 min-h-5 rounded-full"
            [src]="event.guest_thumbnail" />

          <span class="ellipsis flex-1">
            {{ event.guest }}
          </span>
        </span>

        <img
          class="w-5 h-5 min-w-5 min-h-5"
          [src]="'/assets/iconography/' + (event.channel | lowercase) + '-white.svg'"
          [alt]="event.channel"
          onerror="this.src='/assets/iconography/manual-white.svg'" />
      </ng-container>
    </div>

    <!-- tasks container -->
    <ng-container *ngIf="(mode$ | async) === 'tasks'">
      <div
        *ngFor="let task of todaysTasks$ | async"
        class="task"
        [class.checkInOutRole]="task.task_type === 4 || task.task_type === 2"
        [class.cleaningRole]="task.task_type === 1"
        [class.maintenanceRole]="task.task_type === 5"
        [class.task__unassigned]="!task.teammate"
        [class.unassigned__checkInOutRole]="(task.task_type === 4 || task.task_type === 2) && !task.teammate"
        [class.unassigned__cleaningRole]="task.task_type === 1 && !task.teammate"
        [class.unassigned__maintenanceRole]="task.task_type === 5 && !task.teammate"
        [class.multiple_tasks]="(task | hasOverlapWithOtherTasks: property.tasks) > 1"
        (click)="
          dateClicked.emit({
            date: task.start_date,
            property
          })
        ">
        <span *ngIf="(task | hasOverlapWithOtherTasks: property.tasks) === 1">
          {{ task.teammate ? task.teammate.initials : '?' }}
        </span>
        <span *ngIf="(task | hasOverlapWithOtherTasks: property.tasks) > 1">
          {{ task | hasOverlapWithOtherTasks: property.tasks }}
        </span>
      </div>
    </ng-container>

    <!-- date cells -->

    <div
      class="property-date"
      [ngClass]="{
        'last-call-failed': optimisticUpdate?.lastCallFailed
      }"
      [matTooltip]="property[dateString]?.note ? property[dateString]?.note : null"
      [class.is-weekend]="date | isWeekend"
      [class.is-today]="date | isToday"
      [class.is-first-day-of-month]="(date | date: 'd') === '1'"
      [class.is-unavailable]="property[dateString]?.available === false"
      [class.is-manual-block]="isManualBlock$ | async"
      [class.cannot-interact]="(date | isBeforeToday) || optimisticUpdate?.locked"
      [class.is-clicked]="isClicked"
      [class.is-range-selected]="isRangeSelected"
      (click)="dateClicked.emit({ date, property })"
      (mouseover)="dateHovered.emit({ date, property })">
      <div
        *ngIf="(isManualBlock$ | async) && (mode$ | async) === 'occupancy'"
        class="manual-block"
        (click)="$event.stopPropagation()"
        [ngClass]="{
          'prev-sibling': prevSiblingManualBlock$ | async,
          'next-sibling': nextSiblingManualBlock$ | async
        }"></div>
      <!-- has a z-index to ensure that it is overlaid on top of manual blocks and provides a date click target -->
      <span *ngIf="(mode$ | async) === 'occupancy'" class="relative z-20 block h-[40px] ellipsis">
        <div
          class="closed-for-ci"
          *ngIf="property[dateString]?.closed_for_checkin && property[dateString]?.available !== false"></div>
        <div
          class="closed-for-co"
          *ngIf="property[dateString]?.closed_for_checkout && property[dateString]?.available !== false"></div>

        <sbnb-loading-spinner
          *ngIf="optimisticUpdate?.locked"
          class="absolute top-0 right-0"
          [muted]="true"
          [size]="12"></sbnb-loading-spinner>
        <div class="flex flex-col gap-0.5 items-end justify-start p-1">
          <span
            *ngIf="(calendarPermissions$ | async)?.userHasAccessToDisplayPricing"
            class="price-indicator relative z-10 leading-none">
            {{
              (optimisticUpdate?.available ?? property[dateString]?.available)
                ? (Math.round(optimisticUpdate?.price?.amount ?? property[dateString]?.price?.amount)
                  | currency
                    : optimisticUpdate?.price?.currency ?? property[dateString]?.price?.currency
                    : 'symbol'
                    : '1.0-0')
                : ''
            }}
          </span>

          <!-- Min stay indicator -->
          <span
            *ngIf="
              (optimisticUpdate?.min_stay ?? property[dateString]?.min_stay) > 1 &&
              (optimisticUpdate?.available ?? property[dateString]?.available)
            "
            class="min-stay-indicator"
            [matTooltip]="'Minimum length of stay: ' + (optimisticUpdate?.min_stay ?? property[dateString]?.min_stay)">
            <mat-icon>nightlight_outline</mat-icon>
            {{ optimisticUpdate?.min_stay ?? property[dateString]?.min_stay }}
          </span>

          <!-- Note indicator -->
          <span
            *ngIf="property[dateString]?.note && (isManualBlock$ | async) === false"
            class="indicator note-indicator"></span>

          <!-- Failure indicator -->
          <span *sbnbCSDebug="property[dateString]?.failures" class="indicatorfailure-indicator"></span>
        </div>
      </span>
    </div>
  </ng-container>
</div>
<ng-template #loading>
  <div class="property-dates">
    <div
      class="property-date ellipsis"
      [class.is-weekend]="date | isWeekend"
      [class.is-today]="date | isToday"
      [class.is-first-day-of-month]="(date | date: 'd') === '1'"
      [class.cannot-interact]="date | isBeforeToday"></div>
  </div>
</ng-template>
